import React, { useEffect, useState } from "react";

import { BookCheck, Filter, PanelTopOpen, Pencil, Percent } from "lucide-react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardSubtitle,
  CardTitle,
  Col,
  Collapse,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row
} from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../../../actions/baseActions";
import { setObj } from "../../../../../../actions/noteActions";
import Breadcrumb from "../../../../../../components/Breadcrumb";
import Loading from "../../../../../../components/Loading";
import ProtectedRoute from "../../../../../../components/ProtectedRoute";
import SelectFilter from "../../../../../../components/SelectFilter";
import URL from "../../../../../../config/api";
import axios from "../../../../../../config/axios";

const QuestionAnswer = ({ setFunc, question, index, sheet, setHasChecked }) => {
  const answers = [
    { label: "A", value: 1 },
    { label: "B", value: 2 },
    { label: "C", value: 3 },
    { label: "D", value: 4 },
    { label: "E", value: 5 }
  ];

  const changeAnswer = value => {
    const answerSheet = sheet;
    answerSheet.questions[index].current_answer_given = value;
    setFunc(answerSheet);
    setCurrentValue(value);
    setHasChecked(true);
  };

  const [currentValue, setCurrentValue] = useState(
    question.current_answer_given ?? question.previous_answer_given
  );

  return (
    <div className="d-flex w-80 justify-content-between mt-3">
      {answers.map(answer => (
        <div
          key={answer.value}
          className={
            currentValue === answer.value
              ? "question-answer-letter-container-active"
              : "question-answer-letter-container"
          }
          onClick={() => changeAnswer(answer.value)}
        >
          <span
            className={
              currentValue === answer.value
                ? "question-answer-letter-active"
                : "question-answer-letter"
            }
          >
            {answer.label}
          </span>
        </div>
      ))}
    </div>
  );
};

const PartialProgressionGradeSend = props => {
  const [loading, setLoading] = useState();
  const [userListLoading, setUserListLoading] = useState(false);

  const [groupList, setGroupList] = useState();
  const [groupID, setGroupID] = useState(
    props.general.active_roles.group_id ?? null
  );

  const [collapseOpen, setCollapseOpen] = useState();

  const [regionList, setRegionList] = useState();
  const [regionID, setRegionID] = useState(
    props.general.active_roles.region_id ?? null
  );

  const [schoolList, setSchoolList] = useState();
  const [schoolID, setSchoolID] = useState(
    props.general.active_roles.school_id ?? null
  );

  const [classroomList, setClassroomList] = useState();

  const [trailList, setTrailList] = useState();
  const [trailID, setTrailID] = useState();
  const [activityId, setActivityId] = useState();

  const [usersTrailList, setUsersTrailList] = useState();
  const [userId, setUserId] = useState();

  const [answerSheet, setAnswerSheet] = useState();
  const [gradeInputModal, setGradeInputModal] = useState(false);
  const [hasChecked, setHasChecked] = useState(false);

  const [participationInputModal, setParticipationInputModal] = useState(false);
  const [participationPercentage, setParticipationPercentage] = useState(0);

  useEffect(() => {
    (async () => {
      try {
        const response = await axios.get(`${URL.api}access/group/list`, {
          headers: { Authorization: `Bearer ${props.user.token}` }
        });

        const groupList = response.data?.data.map(group => ({
          label: group.name,
          value: group.id
        }));
        setGroupList(groupList);

        const group = props.general.active_roles.group_id ?? 0;
        const region = props.general.active_roles.region_id ?? 0;
        const school = props.general.active_roles.school_id ?? 0;

        if (group) {
          setGroupID(group);
          await getRegions(group);

          if (region) {
            setRegionID(region);
            await getSchools(region, group);
          }
          if (school) {
            setSchoolID(school);
          }
        }
        await getPPTrails();
      } catch {
        toastr.error("Falha", "Falha ao buscar os dados!");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const getRegions = async id => {
    if (!id) {
      setRegionID(0);
      setSchoolID(0);
      return;
    }
    try {
      await axios
        .get(`${URL.api}access/region/listRegionFilter/${id}`, {
          headers: { Authorization: `Bearer ${props.user.token}` }
        })
        .then(resp => {
          const regionList = resp.data?.data.map(region => ({
            label: region.name,
            value: region.id
          }));
          setRegionList(regionList);
        });
    } catch {
      setRegionID(0);
      setSchoolID(0);
    }
  };

  const getSchools = async (id, groupID) => {
    if (!id) {
      setSchoolID(0);
      return;
    }
    try {
      await axios
        .get(`${URL.api}access/school/listSchoolFilter/${groupID}/${id}`, {
          headers: { Authorization: `Bearer ${props.user.token}` }
        })
        .then(resp => {
          const schoolList = resp.data?.data.map(school => ({
            label: school.name,
            value: school.id
          }));
          setSchoolList(schoolList);
        });
    } catch {
      setSchoolID(0);
    }
  };

  const getPPTrails = async () => {
    try {
      const ppTrailListResponse = await axios.get(
        `${URL.api}activity/trail/public?is_partial_progression=true`,
        {
          headers: { Authorization: `Bearer ${props.user.token}` }
        }
      );

      const ppTrailList = ppTrailListResponse.data?.data.map(trail => ({
        label: trail.name,
        value: trail.id
      }));
      setTrailList(ppTrailList);
    } catch {
      setTrailID(0);
    }
  };

  const getTrails = async (
    groupID = null,
    regionID = null,
    schoolID = null
  ) => {
    try {
      axios
        .get(
          `${URL.api}activity/trail_allocation/partial_progression/statistics/getTrailsByFilter`,
          {
            headers: { Authorization: `Bearer ${props.user.token}` },
            params: {
              group_id: groupID,
              region_id: regionID,
              school_id: schoolID
            }
          }
        )
        .then(resp => {
          const trailList = resp.data?.data.map(trail => ({
            label: trail.name,
            value: trail.id
          }));
          setTrailList(trailList);
        });
    } catch {
      setTrailID(0);
    }
  };

  const getStudentList = async () => {
    setUserListLoading(true);
    const studentListReponse = await axios.get(
      `${URL.api}activity/trail_allocation/partial_progression/usersByTrail/${trailID}`,
      {
        headers: {
          Authorization: `Bearer ${props.user.token}`
        },
        params: {
          group_id: groupID,
          region_id: regionID,
          school_id: schoolID
        }
      }
    );
    const userList = studentListReponse?.data?.data?.map(user => ({
      ...user,
      evaluations: user?.evaluations.sort((a, b) => a.step - b.step)
    }));
    setUsersTrailList(userList);
    setUserListLoading(false);
  };

  const openModal = (activityID, userID) => {
    axios
      .post(
        `${URL.api}activity/trail/partial_progression/answers_sheet`,
        {
          activity_id: activityID,
          user_id: userID
        },
        {
          headers: {
            Authorization: `Bearer ${props.user.token}`
          }
        }
      )
      .then(resp => {
        setUserId(userID);
        setActivityId(activityID);
        setAnswerSheet(resp.data.data);
        setGradeInputModal(true);
      });
  };

  const sendAnswerSheet = () => {
    const answers = answerSheet.questions.map(answer => ({
      question_id: answer.question_id,
      option:
        answer.current_answer_given ?? answer.previous_answer_given ?? null
    }));

    let answerSheetPayLoad = {
      activity_id: activityId,
      user_id: userId,
      answers
    };

    axios
      .post(
        `${URL.api}activity/trail/partial_progression/finish`,
        answerSheetPayLoad,
        {
          headers: { Authorization: `Bearer ${props.user.token}` }
        }
      )
      .then(() => {
        setGradeInputModal(false);
        setAnswerSheet(null);
        getStudentList();
      });

    toastr.success(
      "Gabarito enviado com sucesso",
      "A nota do estudante se encontra em processamento"
    );
  };

  const toggleCollapse = id => {
    setCollapseOpen(prevState => (prevState === id ? null : id));
  };

  const sendParticipation = () => {
    const participationPayload = {
      trail_id: trailID,
      user_id: userId,
      completion_percentage: participationPercentage
    };

    axios
      .post(
        `${URL.api}activity/trail/grade_entry/insertParticipation`,
        participationPayload,
        {
          headers: {
            Authorization: `Bearer ${props.user.token}`
          }
        }
      )
      .then(() => {
        setParticipationInputModal(false);
        setParticipationPercentage(0);
      });
    toastr.success("Participação enviada com sucesso");
  };

  return (
    <div>
      <Breadcrumb current={props.currentRoute} />

      <Modal
        isOpen={participationInputModal}
        centered
        toggle={() => {
          setParticipationInputModal(false);
          setParticipationPercentage(0);
        }}
        className="p-5"
      >
        <ModalHeader className="d-flex flex-column">
          <h4>Lançamento de participação</h4>
          <p className="text-muted">
            Preencha a participação do estudante na trilha.
          </p>
        </ModalHeader>
        <ModalBody className="p-4">
          <input
            type="range"
            min="0"
            max="100"
            value={participationPercentage}
            onChange={e => setParticipationPercentage(e.target.value)}
            color="primary"
            className="w-100 mb-3"
          />
          <span>Participação {participationPercentage}%</span>
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => {
              setParticipationInputModal(false);
              setParticipationPercentage(0);
            }}
          >
            Cancelar
          </Button>
          <Button color="primary" onClick={() => sendParticipation()}>
            Confirmar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal
        isOpen={gradeInputModal}
        centered
        toggle={() => {
          setGradeInputModal(false);
          setAnswerSheet(null);
        }}
        className="p-5"
      >
        <ModalHeader className="d-flex flex-column">
          <h4>Lançamento de gabarito</h4>
          <p className="text-muted">Selecione as alternativas marcadas.</p>
        </ModalHeader>
        <ModalBody className="p-4">
          {answerSheet && (
            <>
              {answerSheet?.questions.map((question, index) => (
                <QuestionAnswer
                  key={question.question_id}
                  setFunc={setAnswerSheet}
                  question={question}
                  sheet={answerSheet}
                  index={index}
                  setHasChecked={setHasChecked}
                />
              ))}
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button
            color="secondary"
            onClick={() => {
              setGradeInputModal(false);
              setAnswerSheet(null);
            }}
          >
            Cancelar
          </Button>
          <Button
            color="primary"
            disabled={!hasChecked}
            onClick={() => sendAnswerSheet()}
          >
            Confirmar
          </Button>
        </ModalFooter>
      </Modal>

      <div className="col-12 col-sm-6">
        <h2>Lançamento</h2>
        <p className="text-muted">
          Lançamento de gabarito e participação das progressões parciais.
        </p>
      </div>
      <Col sm="12" md="12" className="mb-4">
        <Row>
          <Col sm="12" md="2">
            <SelectFilter
              title="Grupo"
              placeholder="Selecione um grupo"
              value={groupID}
              setFunction={async id => {
                setGroupID(id);
                getRegions(id);
                await getTrails(id);
              }}
              options={groupList}
              disabled={!!props.general.active_roles.group_id || !trailID}
            />
          </Col>
          <Col sm="12" md="2">
            <SelectFilter
              title="Regiões"
              placeholder="Todas"
              value={regionID}
              setFunction={async id => {
                setRegionID(id);
                getSchools(id, groupID);
                await getTrails(groupID, id);
              }}
              options={regionList}
              disabled={!groupID || !!props.general.active_roles.region_id}
            />
          </Col>
          <Col sm="12" md="2">
            <SelectFilter
              title="Escolas"
              placeholder="Todas"
              value={schoolID}
              setFunction={async id => {
                setSchoolID(id);
                await getTrails(groupID, regionID, id);
              }}
              options={schoolList}
              disabled={!regionID || !!props.general.active_roles.school_id}
            />
          </Col>
          <Col sm="12" md="4">
            <SelectFilter
              title="Trilha"
              placeholder="Selecione uma trilha"
              value={trailID}
              setFunction={id => {
                setTrailID(id);
              }}
              options={trailList}
            />
          </Col>
          <Col
            sm="12"
            md="2"
            className="d-flex justify-content-center align-items-end"
          >
            <Button
              color="primary"
              style={{ minHeight: "38px" }}
              className="d-flex justify-content-center align-items-center w-100"
              onClick={async () => {
                await getStudentList();
              }}
            >
              <Filter size={16} className="mr-2" />
              Filtrar
            </Button>
          </Col>
        </Row>
      </Col>
      {usersTrailList ? (
        <>
          {usersTrailList.length === 0 && (
            <div className="p-3 d-flex align-items-center justify-content-center students-trail-list-table-row">
              Nenhum estudante foi encontrado.
            </div>
          )}
          {usersTrailList.map(student => (
            <Col sm="12" md="6" key={student.id}>
              <Card
                key={student.id}
                className="rounded-lg cursor"
                onClick={() => toggleCollapse(student.id)}
              >
                <div className="d-flex align-items-center p-4 justify-content-between">
                  <div className="d-flex flex-column">
                    {student.name.toUpperCase()}
                    <small className="text-muted">
                      Participação: {student.completion_percentage_average}%
                    </small>
                  </div>
                  <Button color="light">
                    <PanelTopOpen size={16} />
                  </Button>
                </div>
                <Collapse isOpen={collapseOpen === student.id}>
                  <div
                    className="d-flex align-items-center justify-content-between p-4"
                    style={{ overflowX: "auto" }}
                  >
                    {student.evaluations.map((execution, idx) => (
                      <div key={execution.activity_id} className="mr-2">
                        <Button
                          className="align-items-center"
                          color={
                            student.executions.some(
                              exec => exec.activity_id === execution.activity_id
                            )
                              ? "success"
                              : "info"
                          }
                          onClick={() =>
                            openModal(execution.activity_id, execution.user_id)
                          }
                        >
                          {student.executions.some(
                            exec => exec.activity_id === execution.activity_id
                          ) ? (
                            <Pencil size={16} className="mr-2" />
                          ) : (
                            <BookCheck size={16} className="mr-2" />
                          )}
                          P{idx + 1}
                        </Button>
                      </div>
                    ))}
                    <Button
                      color="warning"
                      onClick={() => {
                        setParticipationInputModal(true);
                        setUserId(student.id);
                        setParticipationPercentage(
                          student.completion_percentage_average
                        );
                      }}
                    >
                      <Percent size={16} />
                    </Button>
                  </div>
                </Collapse>
              </Card>
            </Col>
          ))}
        </>
      ) : (
        <>
          {userListLoading ? (
            <Loading />
          ) : (
            <p className="w-100 text-center">
              Selecione ao menos uma trilha e um grupo para o lançamento de
              notas.
            </p>
          )}
        </>
      )}
      <ProtectedRoute routeId={props.currentRoute} />
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

PartialProgressionGradeSend.defaultProps = {
  hideLayout: false,
  guestLogin: true
};

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PartialProgressionGradeSend);
